import { IGif } from '@giphy/js-types'
import { uniqBy } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'
import { webFetch } from 'shared/api'
import useWindowSize from 'shared/hooks/window-size'
import styled, { createGlobalStyle } from 'styled-components'
import ScrollCarousel from '../../scroll-carousel'
import Gif from '../gif'
import InfoOverlay from '../info'

const NAV_HEIGHT = 58
const LIMIT = 25

const NoScrollbars = createGlobalStyle`
    body {
        margin-bottom: 0 !important;
    }
`

const GifWrapper = styled.div`
    padding-bottom: 30px;
    transition: opacity 0.3s ease-in-out;
`

type Props = {
    gif: IGif
    onUpdateGif: (activeGif: IGif) => void
}

const RelatedFeed = ({ gif, onUpdateGif }: Props) => {
    const { innerHeight } = useWindowSize()
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const [gifs, setGifs] = useState<IGif[]>([gif])
    const isFetchingRef = useRef<boolean>(false)
    const isDoneRef = useRef<boolean>(false)
    const maxGifHeight = innerHeight * 0.66

    const fetchGifs = async () => {
        if (isFetchingRef.current || isDoneRef.current) return
        isFetchingRef.current = true
        const { data = [] } = await webFetch.related(`${gif.id}`, { offset: gifs.length - 1, limit: LIMIT })
        isDoneRef.current = data.length < LIMIT
        setGifs(uniqBy([...gifs, ...data], 'id'))
        isFetchingRef.current = false
    }

    const onCarouselUpdate = (index) => {
        onUpdateGif(gifs[index])
        setActiveIndex(index)
        if (index >= gifs.length - 1) {
            fetchGifs()
        }
    }

    useEffect(() => {
        // disable default scrollbars
        fetchGifs()
    }, [gif])

    return (
        <>
            <NoScrollbars />
            <ScrollCarousel height={innerHeight - NAV_HEIGHT} onUpdate={onCarouselUpdate}>
                {gifs.map((gif, i) => (
                    <GifWrapper
                        key={`relatedfeed-${gif.id}`}
                        style={{
                            opacity: activeIndex === i ? 1 : 0.3,
                            pointerEvents: activeIndex === i ? 'auto' : 'none',
                        }}
                    >
                        <Gif gif={gif} maxHeight={maxGifHeight} singleGif>
                            {activeIndex === i && <InfoOverlay gif={gif} rendition="original" isShareLauncher />}
                        </Gif>
                    </GifWrapper>
                ))}
            </ScrollCarousel>
        </>
    )
}

export default RelatedFeed
